import React from 'react';

const AdvertisersServiceCard = () => {
    return (
        <section id="advertisers" className="advertisers-service-sec pt-5 pb-5">
            <div className="container">
                <div className="row">
                    <div className="section-header text-center">
                        <h2 className="fw-bold fs-1">
                            Diversity and
                            <span className="b-class-secondary">Inclusion in Action </span>
                        </h2>
                        {/* <p className="sec-icon">
                            <i className="fa-solid fa-gear"></i>
                        </p> */}
                    </div>
                </div>
                <div className="row mt-5 mt-md-4 row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-3 justify-content-center">
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-solid fa-chart-line"></i>
                            </div>
                            <h3>Tracking Lead</h3>
                            <p>
                                Tracking Lead helps monitor and manage potential customer interactions, ensuring
                                timely follow-ups and improved conversion rates.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-solid fa-users-cog"></i>

                            </div>
                            <h3>Advanced Targeting solution</h3>
                            <p>
                                Advanced Targeting solutions optimize marketing efforts by precisely reaching
                                the right audience with tailored strategies.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-solid fa-globe"></i>
                            </div>
                            <h3>Global Reach & Quality Traffic</h3>
                            <p>
                            Global Reach & Quality Traffic drive your brand's visibility to a worldwide audience, 
                            ensuring valuable and engaged visitors for enhanced business growth.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-solid fa-money-check-dollar"></i>
                            </div>
                            <h3>Flexible pricing models</h3>
                            <p>
                            Flexible pricing models tailored to your needs, offering scalable solutions that fit any budget.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-regular fa-circle-check"></i>
                            </div>
                            <h3>Advanced optimization technologies & methodologies</h3>
                            <p>
                            Leverage advanced optimization technologies and methodologies to enhance performance, efficiency, 
                            and ROI across all campaigns.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="service-card">
                            <div className="icon-wrapper">
                                <i className="fa-solid fa-user-friends"></i>

                            </div>
                            <h3>Dedicated account management team</h3>
                            <p>
                            Benefit from a dedicated account management team that provides personalized support and strategic 
                            guidance to ensure your success.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
      
      `}</style>
        </section>
    );
};

export default AdvertisersServiceCard;
